// src/pages/RisingPage.jsx

import useDiscoveryData from "../hooks/useDiscoveryData";
import DiscoverySectionPage from "../components/discovery/DiscoverySectionPage";
import {
  computeRisingCreators,
  computeFreshMoments,
  computeNearYouCreators,
  getDropAccess,
} from "../utils/discoveryPools";

export default function RisingPage() {
  const {
    creators, drops, dropsByCreator, creatorById,
    followingIds, currentUserCity, sessionSeed,
    purchasedDropIds, subscribedCreatorIds,
    loading,
  } = useDiscoveryData();

  if (loading) {
    return (
      <div className="gal-loading"><span className="gal-loading-text">Loading…</span></div>
    );
  }

  const getItems = ({ niche, search }) =>
    computeRisingCreators(creators, dropsByCreator, { niche, search, seed: sessionSeed, limit: null });

  const getCardProps = (creator) => ({
    creator,
    openDropCount: creator.openCount,
    followingIds,
    isNew: true,
  });

  // Cross-promo: tease Fresh Moments and Near You.
  const freshTeaser = computeFreshMoments(drops, creatorById, { limit: 4 });
  const nearYouTeaser = computeNearYouCreators(creators, dropsByCreator, followingIds, currentUserCity, { seed: sessionSeed, limit: 4 });

  const crossPromo = [
    {
      key: "fresh",
      title: "Fresh Moments",
      seeAllPath: "/gallery/fresh",
      itemType: "drop",
      items: freshTeaser,
      getCardProps: (drop) => ({
        drop,
        creator: creatorById.get(drop.creatorId) || { id: drop.creatorId, displayName: "Creator", avatarUrl: "" },
        access: getDropAccess(drop, purchasedDropIds, subscribedCreatorIds),
      }),
    },
    nearYouTeaser.length > 0 && {
      key: "nearYou",
      title: `Near you${currentUserCity ? ` — ${currentUserCity}` : ""}`,
      seeAllPath: "/gallery/near-you",
      itemType: "creator",
      items: nearYouTeaser,
      getCardProps: (creator) => ({ creator, openDropCount: creator.openCount, followingIds }),
    },
  ].filter(Boolean);

  const allRising = computeRisingCreators(creators, dropsByCreator, { seed: sessionSeed, limit: null });

  return (
    <DiscoverySectionPage
      title="Rising · New to 100VO"
      eyebrow="Reserved spots — never earned by performance."
      itemType="creator"
      getItems={getItems}
      getCardProps={getCardProps}
      emptyMessage="No new creators in this niche just yet — check back soon."
      crossPromo={crossPromo}
      ctaStats={{ seenCount: allRising.length, moreCount: Math.max(creators.length - allRising.length, 0) }}
    />
  );
}